import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MatchParticipantSchema = withDefaults({
  type: 'match-participant',
  objectExtensions: ['match-participant'],
  fields: [
    {
      kind: 'attribute',
      name: 'reportedSalary',
    },
    {
      kind: 'attribute',
      name: 'reportedSalaryDate',
    },
    {
      kind: 'attribute',
      name: 'reportedMonthlyPayment',
    },
    {
      kind: 'attribute',
      name: 'enrollmentState',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'enrolledAt',
    },
    {
      kind: 'attribute',
      name: 'paymentsQualifiedAsOf',
    },
    {
      kind: 'attribute',
      name: 'benefitStartDate',
    },
    {
      kind: 'attribute',
      name: 'benefitEndsAfter',
    },
    {
      kind: 'attribute',
      name: 'accessEndsAfter',
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: 'matchParticipant',
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'matchPlan',
      type: 'match-plan',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'emailAddress',
      type: 'email-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'matchPayments',
      type: 'match-payment',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default MatchParticipantSchema;
